// Keyboard for a pop-up (Lane 1395): focus moves into it when it opens, Tab stays inside
// it, Escape closes it, and focus goes back to what opened it (Codex r1 #8 of the supplier
// history pop-up, shared since the supplier notes pop-up needs the same).
import { useCallback, useEffect, useRef } from 'react';

const FOCUSABLE = 'button:not([disabled]), input:not([disabled]), select:not([disabled]), '
  + 'textarea:not([disabled]), [href], [tabindex]:not([tabindex="-1"])';

export default function useDialogFocus(onClose) {
  const box = useRef(null);
  useEffect(() => {
    const opener = document.activeElement;
    const first = box.current && box.current.querySelector(FOCUSABLE);
    if (first) first.focus();
    return () => { if (opener && opener.isConnected && opener.focus) opener.focus(); };
  }, []);
  const onKey = useCallback((e) => {
    if (e.key === 'Escape') { onClose(); return; }
    if (e.key !== 'Tab' || !box.current) return;
    const items = [...box.current.querySelectorAll(FOCUSABLE)];
    if (items.length === 0) return;
    const first = items[0];
    const last = items[items.length - 1];
    const inside = box.current.contains(document.activeElement);
    if (e.shiftKey && (document.activeElement === first || !inside)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (document.activeElement === last || !inside)) { e.preventDefault(); first.focus(); }
  }, [onClose]);
  useEffect(() => {
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onKey]);
  return box;
}
